import axiosInstance from '../app/axios';

const PRODUCT_PAGE_SIZE = 100;
let allAvailableRequest = null;

const getProductItems = (data) => {
  const items = data?.items || data?.products || data?.data || data || [];
  return Array.isArray(items) ? items : [];
};

const getAll = async (params) => {
  const response = await axiosInstance.get('/products', { params });
  return response.data;
};

const fetchAllAvailable = async (filters) => {
  const firstPage = await getAll({
    ...filters,
    page: 1,
    limit: PRODUCT_PAGE_SIZE,
  });
  const firstPageItems = getProductItems(firstPage);
  const total = Number(firstPage?.total);

  if (!Number.isFinite(total) || total <= firstPageItems.length || firstPageItems.length === 0) {
    return firstPageItems;
  }

  const pageCount = Math.ceil(total / PRODUCT_PAGE_SIZE);
  const remainingPages = await Promise.all(
    Array.from({ length: pageCount - 1 }, (_, index) => getAll({
      ...filters,
      page: index + 2,
      limit: PRODUCT_PAGE_SIZE,
    }))
  );

  return [
    ...firstPageItems,
    ...remainingPages.flatMap(getProductItems),
  ];
};

export const productAPI = {
  getAll,

  getAllAvailable: async (params = {}) => {
    const filters = { ...params };
    delete filters.page;
    delete filters.limit;

    if (Object.keys(filters).length > 0) {
      return fetchAllAvailable(filters);
    }

    if (!allAvailableRequest) {
      allAvailableRequest = fetchAllAvailable(filters).finally(() => {
        allAvailableRequest = null;
      });
    }

    return allAvailableRequest;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/products/${id}`);
    return response.data;
  },
};

export default productAPI;
